import { app } from '../../../../../bootstrap/core';
import { dwsStartedState } from './started.state';
import { dwsStartedComponent } from './started.component';

app.config(dwsStartedState);
app.component(dwsStartedComponent.name, dwsStartedComponent);
